<div #hoverArea class="full-height hover-area" [class.sidebar-opened]="sidebarOpened" (mouseenter)="areaEntered()" (mouseleave)="areaLeft()"></div>
